import { RunningFeatures } from "@sp-crm/core";
import * as React from "react";
import { Redirect } from "react-router";
import { useFeature } from "store/selectors/hooks";

interface FeatureProps {
    name: RunningFeatures;
    children?: React.ReactNode;
}

export const Feature: React.FC<FeatureProps> = props => {
    const { name, children } = props;

    const enabled = useFeature(name);

    if (enabled && children) {
        return children;
    }
    return null;
};

export const PlacementPage: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const enabled = useFeature("placement");
    if (!enabled) return <Redirect to="/tasks" />;
    return <>{children}</>;
};

export const ClientsPage: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const placementEnabled = useFeature("placement");
    const homeCareEnabled = useFeature("homeCarePrototype");
    if (!placementEnabled && !homeCareEnabled) return <Redirect to="/tasks" />;
    return <>{children}</>;
};

export const HomeCareClientsPage: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const homeCareEnabled = useFeature("homeCarePrototype");
    if (!homeCareEnabled) return <Redirect to="/tasks" />;
    return <>{children}</>;
};

export const AntiFeature: React.FC<FeatureProps> = props => {
    const { name, children } = props;

    const enabled = useFeature(name);

    if (!enabled && children) {
        return children;
    }
    return null;
};
